import { useAlertStore, AppAlert } from '@stores/alertStore';
import { Button } from '@components/ui/Button';
import { cn } from '@lib/cn';

export function AlertCard({ alert }: { alert: AppAlert }) {
  const removeAlert = useAlertStore((state) => state.removeAlert);

  const handleClose = () => removeAlert(alert.id);

  let iconClass = 'ri-information-fill text-[text-dark-primary]';
  if (alert.type === 'success') iconClass = 'ri-checkbox-circle-fill text-[--state-success-active]';
  if (alert.type === 'error') iconClass = 'ri-error-warning-fill text-red-400';
  if (alert.type === 'warning') iconClass = 'ri-alert-fill text-yellow-400';

  return (
    <div className="p-[--spacing-10] flex flex-col gap-[--spacing-11] bg-[--base-surface-1] border border-[--base-border] rounded-[--radi-6] shadow-elevation-sm pointer-events-auto w-[546px] max-w-[90dvw]">
      {/* Content row */}
      <div className=" w-full text-left flex flex-row items-start gap-[--spacing-8]">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-[--radi-6] bg-[--base-surface-2] border border-[--base-border] shadow-elevation-sm">
          <i className={cn(iconClass, 'text-[28px]')}></i>
        </div>

        <div className="flex flex-col gap-[--spacing-4] flex-1 mt-2">
          <span className="text-xl font-semibold text-[--text-dark-primary]">{alert.title}</span>
          {alert.message && (
            <span className="text-lg font-medium text-[--text-dark-secondary]">
              {alert.message}
            </span>
          )}
        </div>

        <Button
          onClick={handleClose}
          variant="secondary"
          className="bg-transparent border-none shadow-none p-0 h-fit"
          aria-label="Close"
        >
          <i className="ri-close-line text-[28px] leading-none"></i>
        </Button>
      </div>

      {/* Actions row */}
      {alert.actions && alert.actions.length > 0 && (
        <div className="w-full flex flex-row justify-end gap-[--spacing-7]">
          {alert.actions.map((action, i) => (
            <Button
              key={i}
              variant={action.primary ? 'primary' : 'secondary'}
              className=""
              onClick={() => {
                action.onClick();
                if (action.primary) handleClose();
              }}
            >
              {action.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}

export function AlertContainer() {
  const alerts = useAlertStore((state) => state.alerts);

  if (alerts.length === 0) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[100] flex flex-col gap-4 pointer-events-none">
      {alerts.map((alert) => (
        <AlertCard key={alert.id} alert={alert} />
      ))}
    </div>
  );
}
